import React from 'react';
import bgCenter from 'assets/images/bg_center.png';
import { heroAvatar } from './constants';

const PodiumCard = ({
  large = false,
  name,
  country,
  avatar,
  zoomAvatar = false,
  className = '',
  hideCountry = false
}) => {
  const frameClass = large
    ? 'h-[226px] w-[146px] md:h-[360px] md:w-[240px]'
    : 'h-[156px] w-[96px] md:h-[270px] md:w-[164px]';
  const avatarWrapClass = large
    ? 'h-[74px] w-[74px] md:h-[122px] md:w-[122px] top-[30%] md:top-[30%] -translate-y-1/2'
    : 'h-[52px] w-[52px] md:h-[92px] md:w-[92px] top-[31%] md:top-[31%] -translate-y-1/2';
  const nameBarClass = large
    ? 'left-0 right-0 bottom-[80px] md:bottom-[125px] h-[24px] text-[11px] md:h-[40px] md:text-[18px]'
    : 'left-0 right-0 bottom-[56px] h-[17px] text-[8px] md:bottom-[98px] md:h-[28px] md:text-[12px]';
  const countryClass = large
    ? 'bottom-[55px] md:bottom-[96px] text-[10px] md:text-[16px]'
    : 'bottom-[40px] md:bottom-[72px] text-[8px] md:text-[12px]';
  const nameTextFxClass = large ? 'drop-shadow-[0_1px_1px_rgba(0,0,0,0.45)]' : 'drop-shadow-none';

  return (
    <div className={`text-center ${className}`}>
      <div
        className={`relative mx-auto ${frameClass}`}
        style={{
          backgroundImage: `url(${bgCenter})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div
          className={`relative left-1/2 -translate-x-1/2 ${avatarWrapClass} rounded-full border-[4px] border-[#b8872f] bg-gradient-to-b from-[#f4e3b5] to-[#c79948] flex items-center justify-center overflow-hidden`}
        >
          <img
            src={avatar || heroAvatar}
            alt={name}
            className={`absolute inset-[-1px] h-[calc(100%+2px)] w-[calc(100%+2px)] rounded-full object-cover object-center ${
              zoomAvatar ? 'scale-[1.32]' : ''
            }`}
          />
        </div>

        <div
          className={`absolute z-[2] ${nameBarClass} ${nameTextFxClass} leading-none text-white font-bold flex items-center justify-center px-2 whitespace-nowrap overflow-hidden text-ellipsis`}
        >
          {name}
        </div>
        {!hideCountry ? (
          <div
            className={`absolute z-[2] left-1/2 -translate-x-1/2 ${countryClass} text-white font-bold whitespace-nowrap`}
          >
            {country}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PodiumCard;
